'use strict'

import i18n from 'live/services/i18n'
import pt_br from './i18n/pt_br'
import en_us from './i18n/en_us'

const setLocale = cb => {
    const localeFiles = { pt_br: pt_br, en_us: en_us }
    let intervalId = setInterval(() => {
        var locale = Live.settings && Live.settings.locale ? Live.settings.locale : null

        if (locale != null) {
            i18n.add(localeFiles[locale])
            if (typeof cb == 'function') cb()
            clearInterval(intervalId)
        }
    }, 200)
}

const setViewPort = () => {
    const meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.content = 'width=device-width, initial-scale=1'
    document.getElementsByTagName('head')[0].appendChild(meta)
}

export default cb => {
    setViewPort()
    setLocale(cb)
    document.title = 'Reports Approval'
}
